import { trim } from "lodash";

export function getArchiveIcon(
  archive: string,
  size?: number | undefined
): string {
  const animateClass = typeof size === "undefined" ? "animate-pulse" : "";

  let iconClass = "";

  switch (archive) {
    case "online": {
      iconClass = "fa-light fa-database";
      break;
    }
    case "nearline": {
      iconClass = "fa-light fa-server";
      break;
    }
    case "offline": {
      iconClass = "fa-light fa-tape";
      break;
    }
    case "sharing": {
      iconClass = "fa-light fa-share-alt-square";
      break;
    }
    case "backup": {
      iconClass = "fa-light fa-clock-rotate-left";
      break;
    }
    default: {
      iconClass = "fa-light fa-question-circle";
      break;
    }
  }

  return trim(`${iconClass} ${animateClass}`);
}
